import { LMCRequest as LmcRequest } from './types'
import { Need } from '@lmc/ts-common'
import { getJSON } from 'common/services/api'

const list: LmcRequest<{ result: Need[], count: number }> = () =>
  getJSON({ url: '/api/list/needs' })

export const needsRequests = {
  list,
}
